import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-circle\"><title>plus-circle</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M11.2 11.2V8.796a.8.8 0 1 1 1.6 0V11.2h2.404a.8.8 0 1 1 0 1.6H12.8v2.404a.8.8 0 1 1-1.6 0V12.8H8.796a.8.8 0 1 1 0-1.6H11.2zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1.6a6.4 6.4 0 1 0 0-12.8 6.4 6.4 0 0 0 0 12.8z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol